module.exports = __webpack_public_path__ + "static/zenpharm-icon-f9dddb77ddb81318937849c26a2a9785.svg";